const cq = (query: string) => `[class*="${query}"]`
export default cq
